import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function WorkSteps() {
  return (
    <Box component="section" sx={{ py: { xs: 6, md: 8 }, bgcolor: 'background.default' }}>
      <Container maxWidth="md">
        <Typography
          variant="subtitle1"
          align="center"
          color="text.primary"
          sx={{ mb: { xs: 4, md: 6 } }}
        >
          Easy steps to apply
        </Typography>

        {[ 
          {
            number: '#1',
            title: 'Apply online',
            description: 'Provide your Real estate Agent/Landlord details.',
            image: 'https://umsousercontent.com/lib_jgVHuWfNVCXsSZpf/aolq0zoctatwbqm6.svg',
            reverse: false,
          },
          {
            number: '#2',
            title: 'Get approved',
            image: 'https://umsousercontent.com/lib_wfKJyoksALKsfAWv/yh2unvna2ak8yuk6.png?w=350&h=350',
            reverse: true,
          },
          {
            number: '#3',
            title: 'We pay your Bond',
            description: 'Pay 25% of the bond upfront + $99 admin fee. BondPay will email the receipt to confirm your bond has been paid.',
            image: 'https://umsousercontent.com/lib_jgVHuWfNVCXsSZpf/j4y1cw2jf8lzbn16.svg',
            reverse: false,
          },
          {
            number: '#4',
            title: 'You pay us back in 6 weeks',
            image: 'https://umsousercontent.com/lib_jgVHuWfNVCXsSZpf/y43513uyrn6kyjdd.svg',
            reverse: true,
          },
          {
            number: '#5',
            title: 'Move in your new place',
            description: 'Start living life sooner!',
            image: 'https://umsousercontent.com/lib_wfKJyoksALKsfAWv/735duoxtar45t195.png?w=350&h=350',
            reverse: false,
          },
        ].map(({ number, title, description, image, reverse }, index) => (
          <Stack
            key={index}
            direction={{ xs: 'column', md: reverse ? 'row-reverse' : 'row' }}
            spacing={{ xs: 4, md: 6 }}
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: { xs: 6, md: 8 } }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="h1"
                color="grey.200"
                sx={{ fontSize: { xs: 48, md: 64 }, fontWeight: 700, lineHeight: 1, mb: -1 }}
              >
                {number}
              </Typography>
              <Typography variant="h5" fontWeight={700} gutterBottom>
                {title}
              </Typography>
              {description && (
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                  {description}
                </Typography>
              )}
              <Button
                variant="outlined"
                size="large"
                component={RouterLink}
                to="/apply"
              >
                Get Started
              </Button>
            </Box>
            <Box
              component="img"
              src={image}
              alt={title}
              sx={{ flex: 1, maxWidth: { xs: '100%', md: 320 }, width: '100%' }}
            />
          </Stack>
        ))}
      </Container>
    </Box>
  );
}
